import { FC } from 'react';
import { IButtonProps } from './types';
import styles from './button.module.scss';

export const Button: FC<IButtonProps> = ({ onClick, title, icon, stylesProp, isDisabled = false, classNameProp }) => {
  return (
    <button
      className={`${styles.button} ${classNameProp} ${isDisabled && styles.buttonDisabled}`}
      style={stylesProp}
      type='button'
      onClick={onClick}
      disabled={isDisabled}>
      <span>{icon}</span>
      <span className={styles.btnTitle}>{title}</span>
    </button>
  );
};
